const NoMatch = () => {
    return (
        <>
            <title>404 | AAA Life</title>
            <main style={{ padding: "1rem" }}>
                <p>There's nothing here!</p>
            </main>
        </>
    );
};

export default NoMatch;
